// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.printable-content {
  -webkit-text-size-adjust: none;
          text-size-adjust: none;
  background-color: white;
}

.fixed-bottom {
  position: fixed;
  bottom: 15px;
}
.fixed-bottom.left {
  left: 15px;
}
.fixed-bottom.right {
  right: 15px;
}

@media print {
  .fixed-bottom {
    display: none !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/view/page/print/print.component.scss"],"names":[],"mappings":"AAAA;EACI,8BAAA;UAAA,sBAAA;EACA,uBAAA;AACJ;;AACA;EACI,eAAA;EACA,YAAA;AAEJ;AADI;EAAS,UAAA;AAIb;AAHI;EAAU,WAAA;AAMd;;AAHA;EACI;IAAgB,wBAAA;EAOlB;AACF","sourcesContent":[".printable-content {\n    text-size-adjust: none;\n    background-color: white;\n}\n.fixed-bottom {\n    position: fixed;\n    bottom: 15px;\n    &.left { left: 15px; }\n    &.right { right: 15px; }\n}\n\n@media print {\n    .fixed-bottom { display: none !important;}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
